import { createApi } from '@reduxjs/toolkit/query/react';
import { trackerAiBaseQuery } from './trackerAiBaseQuery';

const trackerAiApi = createApi({
  reducerPath: 'trackerAi',
  baseQuery: trackerAiBaseQuery,
  tagTypes: [
    'Projects',
    'Project',
    'ProjectInsight',
    'ProjectActivityRange',
    'Prompts',
    'PromptInsight',
    'PromptHistory',
    'PromptBrandAggregation',
    'PromptOverview',
    'VisibilitySummary',
    'VisibilityTrend',
    'Executions',
    'Execution',
    'Domains',
    'BrandAliases',
    'Competitors',
    'CompetitorIntelligence',
    'Topics',
    'SourceInsights',
    'Models'
  ],
  endpoints: () => ({})
});

export default trackerAiApi;
